module.exports = __webpack_public_path__ + "img/wtc.7de51d84.svg";